import { COLOURS, STRING } from 'resources'
import { basicAccountIcon, trustedAccountIcon, vipAccountIcon } from 'resources/images'

export const ACCOUNT_STATUS = {
  basic: {
    color: COLOURS.primaryYellow,
    tintColor: COLOURS.neutralBlack,
    icon: basicAccountIcon,
    description: STRING.navMenu.status.basic,
  },
  trusted: {
    color: COLOURS.primaryBlue,
    tintColor: COLOURS.neutralWhite,
    icon: trustedAccountIcon,
    description: STRING.navMenu.status.trusted,
  },
  vip: {
    color: COLOURS.secondaryPurple1,
    tintColor: COLOURS.neutralWhite,
    icon: vipAccountIcon,
    description: STRING.navMenu.status.vip,
  },
}
